import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-dados-condutor',
  templateUrl: './dados-condutor.component.html',
  styleUrls: ['./../consulta-cnh.component.css', './dados-condutor.component.css']
})
export class DadosCondutorComponent implements OnInit {

  @Input() dados: any;
  public naoSolicitou: Boolean = false;
  public naoEncontrouRegistros: Boolean = false;

  constructor() {}

  ngOnInit() {
    if(this.dados.Dados_Condutor === undefined){
      this.naoEncontrouRegistros = true;
    }
  }

}
